/**
 * The AdditionalOrderItemConfiguration is an object with additional info about VVS and personal use
 * it is set for every ticket (order-item * quantity)
 *
 */
import {Model} from './Model';

export class PublicTransportConfig extends Model {
  passengerName: string | null = null;
  passengerSurname: string | null = null;
  usePubTrans: boolean = false;
  selectedDate: string | null = null;
  productId: number | null = null;
  slotId: number | null = null;

  constructor(data: any) {
    super(data);
    this.passengerName = data.passengerName;
    this.passengerSurname = data.passengerSurname;
    this.usePubTrans = data.usePubTrans;
    this.selectedDate = data.selectedDate;
    this.productId = data.productId;
    this.slotId = data.slotId;
  }

  toString(): string {
    return ``;
  }
}
